import React, { useEffect, useState } from "react";
import { writeFile, utils } from "xlsx";
import Box from "@material-ui/core/Box";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardHeader from "@material-ui/core/CardHeader";
import Container from "@material-ui/core/Container";
import { makeStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Pagination from "@material-ui/lab/Pagination";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

// core components
import Header from "../../components/Headers/Header.js";

import componentStyles from "../../assets/theme/views/admin/tables.js";
import { withAppContext } from "../../contextApi/Auth/index.js";

import axios from "axios";
import "sweetalert2/src/sweetalert2.scss";
import { BACKEND_URL } from "../../env.js";
import { Input } from "antd";

const useStyles = makeStyles(componentStyles);

const Order = () => {
    const classes = useStyles();
    const [AllOrder, setAllOrder] = useState([]);
    const [FilteredOrders, setFilteredOrders] = useState([]);
    const [statusOptions] = useState(["pending", "payed", "returned"]);
    const [fromDate, setFromDate] = useState(""); // For "From Date"
    const [toDate, setToDate] = useState(""); // For "To Date"
    const [number, setNumber] = useState(""); // For "To Date"
    const [pageNo, setPageNo] = useState(1)
    const [totalOrders, setTotalOrders] = useState(0);
    const [openIdModal, setOpenIdModal] = useState(false);
    const [editMargin, setEditMargin] = useState(null);
    const [profitMargin, setProfitMargin] = useState("");
    const ordersPerPage = 20;
    useEffect(() => {
        const GetAllOrder = () => {
            axios
                .get(`${BACKEND_URL}/orders`, {
                    params: { page: pageNo, limit: ordersPerPage },
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                })
                .then((res) => {
                    console.log(res.data, "order");
                    setAllOrder(res?.data?.orders);
                    setFilteredOrders(res?.data?.orders);
                    setTotalOrders(res?.data?.totalOrders)
                })
                .catch((err) => console.log(err));
        };
        GetAllOrder();
    }, [pageNo]);
    const handlePageChange = (event, value) => {
        setPageNo(value);
    };
    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return `${date.getDate()}/${date.getMonth() + 1}/${date.getFullYear()}`;
    };

    const handleStatusChange = (orderId, newStatus) => {
        axios
            .put(
                `${BACKEND_URL}/orders/${orderId}`,
                { profitStatus: newStatus },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                setAllOrder((prevOrders) =>
                    prevOrders.map((order) =>
                        order.id === orderId ? { ...order, profitStatus: newStatus } : order
                    )
                );
            })
            .catch((err) => console.log(err));
    };


    // Handle Date Filter
    const handleFilter = () => {
        const from = new Date(fromDate).setHours(0, 0, 0, 0);
        const to = new Date(toDate).setHours(23, 59, 59, 999);

        const filtered = AllOrder.filter((order) => {
            const orderDate = new Date(order.orderDate).getTime();
            const isDateValid = (!fromDate || orderDate >= from) && (!toDate || orderDate <= to);
            const isNumberValid = !number || order.phoneNumber?.includes(number); // Check if phone number includes the entered number
            return isDateValid && isNumberValid;
        });

        setFilteredOrders(filtered);
    };

    const handleClearFilter = () => {
        setFilteredOrders(AllOrder);
        setFromDate("");
        setToDate("");
        setNumber("")
    };
    const handleOpenIdModal = (id) => {
        console.log(id, "orderproduct");

        setEditMargin(id);
        setOpenIdModal(true);
    };
    const handleIdCloseModal = () => {
        setOpenIdModal(false);
        setEditMargin(null);
        setProfitMargin("")
    };
    const handleSubmitId = () => {
        axios
            .put(
                `${BACKEND_URL}/orders/${editMargin}`,
                { profileMargin: profitMargin },
                {
                    headers: {
                        token: localStorage.getItem("Token"),
                    },
                }
            )
            .then((res) => {
                // if(res?.id){
                window.location.reload()
                // }
                setAllOrder((prevOrders) =>
                    prevOrders.map((order) =>
                        order.id === editMargin ? { ...order, profileMargin: profitMargin } : order
                    )
                );
            })
            .catch((err) => console.log(err));
    };
    return (
        <>
            <Header />
            <Container
                maxWidth={false}
                component={Box}
                marginTop="-6rem"
                classes={{ root: classes.containerRoot }}
            >
                <Card classes={{ root: classes.cardRoot }}>
                    <CardHeader
                        className={classes.cardHeader}
                        title="Available Transaction"
                        titleTypographyProps={{
                            component: Box,
                            marginBottom: "0!important",
                            variant: "h3"
                        }}
                    />
                    <Box display="flex" justifyContent="space-between" alignItems="center" padding="1rem">
                        <TextField
                            label="From Date"
                            type="date"
                            value={fromDate}
                            onChange={(e) => setFromDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="To Date"
                            type="date"
                            value={toDate}
                            onChange={(e) => setToDate(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <TextField
                            label="Number"
                            placeholder="Enter A Number"
                            type="text"
                            value={number}
                            onChange={(e) => setNumber(e.target.value)}
                            InputLabelProps={{ shrink: true }}
                        />
                        <Button variant="contained" color="primary" onClick={handleFilter}>
                            Apply Filter
                        </Button>
                        <Button variant="contained" color="secondary" onClick={handleClearFilter}>
                            Clear Filter
                        </Button>

                    </Box>
                    {FilteredOrders && FilteredOrders?.length >= 1 ? (
                        <TableContainer>
                            <Box component={Table} alignItems="center" marginBottom="0!important">
                                <TableHead>
                                    <TableRow>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Order ID</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Order Date</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Email</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Store Name</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Profit Margin</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Add Profit Margin</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Bank Name</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Account Title</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Account Number</TableCell>
                                        <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootHead}>Status</TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {FilteredOrders.sort((a, b) => new Date(b.orderDate) - new Date(a.orderDate))?.map((order) => {
                                        console.log(order);

                                        return (
                                            <TableRow key={order.orderId}>
                                                <TableCell className={classes.tableCellRoot + " " + classes.tableCellRootBodyHead}>
                                                    <Box alignItems="center" display="flex">
                                                        <Box display="flex" alignItems="flex-start">
                                                            <Box fontSize=".875rem" component="span">{order.orderId}</Box>
                                                        </Box>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{formatDate(order?.orderDate)}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order.email}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order?.user?.storeName}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order.profileMargin || 0}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">
                                                        <Button onClick={() => handleOpenIdModal(order.id)}>Add Profit Margin</Button>
                                                    </Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order.user?.bankNumber}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order.user?.accountTitle}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Box paddingTop=".35rem" paddingBottom=".35rem">{order.user?.accountNumber}</Box>
                                                </TableCell>
                                                <TableCell className={classes.tableCellRoot}>
                                                    <Select
                                                        value={order.profitStatus}
                                                        onChange={(e) => handleStatusChange(order.id, e.target.value)}
                                                        variant="outlined"
                                                        fullWidth
                                                    >
                                                        {statusOptions.map((status) => (
                                                            <MenuItem key={status} value={status}>
                                                                {status}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </TableCell>

                                            </TableRow>
                                        )
                                    })}
                                </TableBody>
                            </Box>
                        </TableContainer>
                    ) : (
                        <div
                            style={{
                                width: "100%",
                                display: "flex",
                                alignContent: "center",
                                alignItems: "center",
                                justifyContent: "center"
                            }}
                        >
                            <h1>No Order to Show</h1>
                        </div>
                    )}
                    <Box
                        classes={{ root: classes.cardActionsRoot }}
                        component={CardActions}
                        justifyContent="flex-end"
                    >
                        <Pagination
                            count={Math.ceil(totalOrders / ordersPerPage)}
                            page={pageNo}
                            onChange={handlePageChange}
                            color="primary"
                            variant="outlined"
                        />
                    </Box>
                </Card>
                <Dialog open={openIdModal} onClose={handleIdCloseModal} maxWidth="xs" fullWidth>
                    <DialogTitle>Profit Margin</DialogTitle>
                    <DialogContent>
                        <Input placeholder="Profit Margin" value={profitMargin} onChange={(e) => setProfitMargin(e.target.value)} />
                    </DialogContent>
                    <DialogActions>
                        <Button onClick={handleIdCloseModal} color="primary">
                            Close
                        </Button>
                        <Button onClick={handleSubmitId} color="success">
                            Submit
                        </Button>
                    </DialogActions>
                </Dialog>
            </Container>
        </>
    );
};

export default withAppContext(Order);
